import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  sharedEmail : string
  shareTimerStart : Date
  shareTimerEnd : Date
  sharedStore : string
  private statusSubject = new Subject<string>();
  private notificationSubject = new Subject<boolean>();
  private navServiceDataSubject = new Subject<boolean>();
  private displayNotificationSubject = new Subject<any>();

  constructor() { }
  setMessage(data: string)
  {
    this.sharedEmail = data;
  }
  getMessage()
  {
    return this.sharedEmail;
  }

  setStartTime(data:Date)
  {
    this.shareTimerStart = data;
  }
  getStartTime(data:Date)
  {
    return this.shareTimerStart
  }

  
  setEndTime(data:Date)
  {
    this.shareTimerEnd = data;
  }
  getEndTime(data:Date)
  {
    return this.shareTimerEnd
  }

  setStore(data: string)
  {
    this.sharedStore = data;
  }
  getStore()
  {
    return this.sharedStore;
  }

  getStatusObservable() {
    return this.statusSubject.asObservable();
  }

  updateStatus(newStatus: string) {
    this.statusSubject.next(newStatus);
  }

  
  getNotificationObservable() {
    return this.notificationSubject.asObservable();
  }

  updateNotification(refresh: boolean) {
    this.notificationSubject.next(refresh);
  }

  
  getNavServiceDataObservable() {
    return this.navServiceDataSubject.asObservable();
  }

  updateNavServiceData(refresh: boolean) {
    this.navServiceDataSubject.next(refresh);
  }

  
  updateNotificationDisplay(data: any) {
    this.displayNotificationSubject.next(data);
  }
  getNotificationDisplayObs() {
    return this.displayNotificationSubject.asObservable();
  }

}
